// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3MnNA","col":"CardReaderDesc_col__3fbHR","label":"CardReaderDesc_label__2S1QX"};